var SECONDARY_MEDIA_BEHAVIOUR = {
    APPEARS: 'APPEARS',
};
export default SECONDARY_MEDIA_BEHAVIOUR;
//# sourceMappingURL=secondaryMediaBehaviour.js.map